var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z",
    fill: "#EAF1FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59.5H19C18.175 59.5 17.5 60.175 17.5 61C17.5 61.825 18.175 62.5 19 62.5H61C61.825 62.5 62.5 61.825 62.5 61C62.5 60.175 61.825 59.5 61 59.5Z",
    fill: "#4F8AFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 54.5951H58V39.8051H58.93C59.755 39.8051 60.43 39.1301 60.43 38.3051C60.43 37.4801 59.755 36.8051 58.93 36.8051H21.07C20.245 36.8051 19.57 37.4801 19.57 38.3051C19.57 39.1301 20.245 39.8051 21.07 39.8051H22V54.5951H20.5C19.675 54.5951 19 55.2701 19 56.0951C19 56.9201 19.675 57.5951 20.5 57.5951H59.5C60.325 57.5951 61 56.9201 61 56.0951C61 55.2701 60.325 54.5951 59.5 54.5951ZM35.71 54.5951H30.595V39.8051H35.71V54.5951ZM49.405 54.5951H44.29V39.8051H49.405V54.5951Z",
    fill: "#4F8AFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.69 28.435L40.69 17.665C40.255 17.44 39.745 17.44 39.325 17.665L18.31 28.435C17.815 28.69 17.5 29.2 17.5 29.77V33.4C17.5 34.225 18.175 34.9 19 34.9H61C61.825 34.9 62.5 34.225 62.5 33.4V29.77C62.5 29.2 62.185 28.69 61.69 28.435ZM40.03 29.365C38.815 29.365 37.78 28.375 37.78 27.16C37.78 25.945 38.725 24.955 39.94 24.955H40.03C41.245 24.955 42.235 25.945 42.235 27.16C42.235 28.375 41.245 29.365 40.03 29.365Z",
    fill: "#4F8AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan3);
export default __webpack_public_path__ + "static/media/loan3.c544e9208d001a3ec2f40f59dc81a684.svg";
export { ForwardRef as ReactComponent };